import Messaging from "@/app/(app)/(crew)/messaging";

export default Messaging;
